import { render, staticRenderFns } from "./SpecimenHeader.vue?vue&type=template&id=0aa82a51"
import script from "./SpecimenHeader.vue?vue&type=script&lang=js"
export * from "./SpecimenHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports